<template>
  <div>
    <Player />
    <div style=" background: #f3f3f3">
      <CellGroup title="基本信息">
        <Cell value-class="cell-value" title="设备名称" :value="device.name" />
        <Cell value-class="cell-value" title="设备编号" :value="device.sn" />
        <Cell
          value-class="cell-value"
          title="产品名称"
          :value="device.productName"
        />
        <Cell
          value-class="cell-value"
          title="最后在线"
          :value="device.heartBeatTime"
        />

        <Cell
          :value-class="`device-state-font-${device.deviceState}`"
          title="设备状态"
          :value="deviceStateDICT"
        />
        <Cell
          :value-class="`data-state-${device.dataState}`"
          title="停用状态"
          :value="deviceDataStateDICT"
        />
        <Cell
          :value-class="`arm-state-${device.armState}`"
          title="布防状态"
          :value="deviceArmStateDICT"
        />

        <Cell
          value-class="cell-value"
          title="所属单位"
          :value="device.unitName"
        />
        <Cell
          value-class="cell-value"
          title="归属分组"
          :value="device.unitGroupName"
        />
        <Cell
          value-class="cell-value"
          title="所属区域"
          :value="device.areaName"
        />
        <Cell
          value-class="cell-value"
          title="详细地址"
          :value="device.address"
        />
        <Cell
          value-class="cell-value"
          title="安装位置"
          :value="device.installLocation"
        />
        <div
          style="display:flex;justify-content : space-between;width:78%;margin:auto;margin-top:8px;"
        >
          <UploadImage
            style="margin-left:-15px"
            :imageList="[device.image1]"
            top="设备图"
            :count="1"
          />
          <UploadImage
            style="margin-left:-15px"
            :imageList="[device.image2]"
            top="标签图"
            :count="1"
          />
          <UploadImage
            style="margin-left:-15px"
            :imageList="[device.image3]"
            top="安装图"
            :count="1"
          />
          <UploadImage
            style="margin-left:-15px"
            :imageList="[device.image4]"
            top="全景图"
            :count="1"
          />
        </div>
      </CellGroup>
      <CellGroup title="实时数据">
        <Cell
          v-for="item in device.shadowProp"
          :key="item.id"
          value-class="cell-value"
          :title="item.name"
          :value="item.value"
        />
        <div style="height:50px;">&nbsp;</div>
      </CellGroup>
      <Popup v-model="updateShow" style="width: 90%" closeable>
        <NavBar title="更换设备" />
        <Field
          clearable
          v-model="updateSn"
          label="设备编号"
          required
          placeholder="请输入设备编号"
          :rules="[{ required: true, message: '设备编号不为空' }]"
        />
        <Field
          clearable
          v-model="ioTHubRemark"
          label="验证码"
          required
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '验证码必填' }]"
          v-if="code"
        />
        <!-- <WeChatIcon slot="right-icon" name="scan" @click="qrScan"/> -->
        <div
          style="display:flex;align-items: center;justify-content: space-evenly;"
        >
          <WeChatIcon
            name="scan"
            @click="qrScan"
            :style="{ fontSize: '26px' }"
          />
          <Button
            type="info"
            block
            style="width: 80% ; margin: 10px 0;"
            @click="changDevice"
            >确认更换</Button
          >
        </div>
      </Popup>
      <div v-if="getActions.length" class="fixed-button" @click="changeShow">
        <WeChatIcon name="setting" :style="{ fontSize: '26px' }" />
      </div>
      <ActionSheet v-model="show" v :actions="getActions" @select="onSelect" />
    </div>
  </div>
</template>

<script>
import {
  ActionSheet,
  Button,
  Cell,
  CellGroup,
  Dialog,
  Field,
  NavBar,
  Popup,
} from "vant";
import UploadImage from "@/components/UploadImage";
import WeChatIcon from "@/components/Icon/WeChatIcon";
import Player from "@/router/player/";
import * as DICT from "@/utils/dict";
import { mapGetters } from "vuex";
import wx from "weixin-js-sdk";

export default {
  components: {
    Button,
    Field,
    NavBar,
    Popup,
    ActionSheet,
    CellGroup,
    Cell,
    UploadImage,
    Dialog,
    WeChatIcon,
    Player,
  },
  props: ["device", "deviceId"],
  data() {
    return {
      show: false,
      updateSn: null,
      ioTHubRemark: null,
      code: false,
      updateShow: false,
      actions: [
        { type: "UnBind", name: "解绑", permiss: "DEVICE_OPERATE" },
        { type: "Arm", name: "设备布防", permiss: "DEVICE_OPERATE" },
        { type: "Disarm", name: "设备撤防", permiss: "DEVICE_OPERATE" },
        { type: "Enable", name: "设备启用", permiss: "DEVICE_OPERATE" },
        { type: "Disable", name: "设备停用", permiss: "DEVICE_OPERATE" },
        { type: "update", name: "设备修改", permiss: "DEVICE_EDIT" },
        { type: "delete", name: "设备拆除", permiss: "DEVICE_DELETE" },
        { type: "updateDevice", name: "更换设备", permiss: "DEVICE_EDIT" },
        {
          type: "handleAlarm",
          name: "警情处理",
          permiss: "DEVICE_HANDLE_ALARM",
        },
      ],
      // device: {image1: [], image2: [], image3: [], image4: []},
    };
  },
  computed: {
    // image1(){
    //     return this.device.image1?[ this.device.image1]:[]
    // },
    ...mapGetters({ permissions: "global/permissions" }),
    getActions() {
      const ret = this.actions.filter(
        (item) =>
          !(
            item.type == this.device.armState ||
            item.type == this.device.dataState ||
            !this.permissions.includes(item.permiss)
          )
      );
      return ret;
    },
    deviceStateDICT() {
      return DICT.getValue("DEVICE_STATE_TYPE", this.device.deviceState);
    },
    deviceDataStateDICT() {
      const dict = { Enable: "启用", Disable: "停用" };
      return dict[this.device.dataState] || this.device.dataState;
    },
    deviceArmStateDICT() {
      return DICT.getValue("ARM_STATE", this.device.armState);
    },
  },
  created() {},
  mounted() {},
  methods: {
    changDevice() {
      this.$toast.loading("正在处理中...");
      this.$http.tokiot.device
        .replaceDevice({
          id: this.deviceId,
          sn: this.updateSn,
          ioTHubRemark: this.ioTHubRemark,
        })
        .then((res) => {
          if (res) {
            this.$toast.success("更换成功");
            setTimeout(() => {
              this.$router.history.go(-1);
            }, 500);
          } else {
            this.$toast.fail(res.message);
          }
        });
    },
    changeShow() {
      if (
        this.device.productForm == `Camera` &&
        this.device.productModel.indexOf(`HIK`) == 0
      ) {
        this.code = true;
      } else {
        this.code = false;
      }
      this.show = !this.show;
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      if (item.type == "player") {
        this.$router.push("/player/" + this.device.id);
      } else if (item.type === `UnBind`) {
        Dialog.confirm({
          message: `危险操作！点击确认后，设备启用状态变更为"禁用"、设备绑定分组关系解除！`,
        }).then(() => {
          this.$http.tokiot.device
            .changeState({ type: item.type, idList: this.deviceId })
            .then((res) => {
              this.$toast.loading("正在处理中...");
              if (res) {
                this.$toast.success("成功");
                this.device.unitGroupId = null;
                this.device.unitGroupName = null;
              }
            });
        });
      } else {
        Dialog.confirm({ message: "是否执行" + item.name + "操作" }).then(
          () => {
            if (item.type == "update") {
              this.$router.push("/device/updateDevice/" + this.deviceId);
            } else if (item.type == "handleAlarm") {
              this.$router.push("/alarm/alarmDeal/" + this.deviceId);
            } else if (item.type == "delete") {
              this.$toast.loading("正在处理中...");
              this.$http.tokiot.device
                .delete({ id: this.deviceId })
                .then((res) => {
                  if (res) {
                    this.$toast.success("删除成功");
                    setTimeout(() => {
                      this.$router.history.go(-1);
                    }, 500);
                  } else {
                    this.$toast.fail(res.message);
                  }
                });
            } else if (item.type == "updateDevice") {
              this.updateShow = true;
              this.qrScan();
            } else {
              this.$http.tokiot.device
                .changeState({ type: item.type, idList: this.deviceId })
                .then((res) => {
                  this.$toast.loading("正在处理中...");
                  if (res) {
                    this.$toast.success("成功");
                    switch (item.type) {
                      case "Arm":
                        this.device.armState = "Arm";
                        break;
                      case "Disarm":
                        this.device.armState = "Disarm";
                        break;
                      case "Enable":
                        this.device.dataState = "Enable";
                        break;
                      case "Disable":
                        this.device.dataState = "Disable";
                        break;
                    }
                  }
                });
            }
          }
        );
      }
    },
    //更换设备的扫一扫
    qrScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let index = res.resultStr.indexOf(`CODE_128,`);
          if (index > -1) {
            let len = res.resultStr.length;
            res.resultStr = res.resultStr.slice(index + 9, len - 1);
          }
          if (This.code && res.resultStr.indexOf(`ys7`) == 0) {
            let Str = res.resultStr.replace(/\s*/g, "");
            This.updateSn = Str.substring(3, 12);
            This.ioTHubRemark = Str.substring(12, 18);
          } else if (This.device.productKey === `pro_06bc1eaf688f`) {
            let str = res.resultStr;
            let arr = str.split(`;`);
            if (Array.isArray(arr) && arr.length !== 0) {
              This.updateSn = arr[0];
            } else {
              This.updateSn = res.resultStr;
            }
          } else if (This.device.productKey === `pro_c0aff6a3d5a5`) {
            let str = res.resultStr;
            let arr = str.split(`,`);
            if (Array.isArray(arr) && arr.length !== 0) {
              This.updateSn = arr[0];
            } else {
              This.updateSn = res.resultStr;
            }
          } else {
            This.updateSn = res.resultStr;
          }
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.fixed-button {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  bottom: 30px;
  left: 50%;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background: rgb(108, 81, 224);
  margin-left: -25px;
  box-shadow: 3px 3px 5px rgb(180, 180, 180);
  color: #fff;
}
.van-cell__value {
  overflow: visible;
}
</style>
